module.exports = __webpack_public_path__ + "img/appointmentDone.ef170e18.png";